export default __webpack_public_path__ + "static/media/KZ.T.05.2255.1bd2df12.svg";